import React,{ useState} from 'react'
import './navbar.css'
import { RiMenu3Line, RiCloseLine } from 'react-icons/ri';
import logo from '../../assets/eyes.gif'
import rarible from '../../assets/rarible.png'
import opensea  from '../../assets/Logomark-White.png'
import {  Link } from "react-router-dom";
import { AiFillHeart, AiFillInstagram, AiFillTwitterCircle, AiOutlineInstagram, AiOutlineTwitter } from 'react-icons/ai';

const Menu = () => (
  <>
     <Link to="https://parlockart.xyz"><p>Latest HexaEye NFT</p> </Link>
  </>
 )

 const Navbar = () => {
  const [toggleMenu,setToggleMenu] = useState(false)
   const [user,setUser] = useState(false)

  const handleLogout = () => {
    setUser(false);
  }
  const handleLogin = () => {
    setUser(true);
  }

  return (
    <div className='navbar' style={{position:'fixed'}}>
      <div className="navbar-links">
        <div className="navbar-links_logo">
          <img src={logo} alt="logo" style={{height: '60%', width: '60%', borderRadius: 100, borderColor:'#ffff', borderWidth: 1}}/>
          <Link to="/"> 
            <h1 style={{marginLeft: 10}}>ParLock</h1>
          </Link>
        </div>
        <div className="navbar-links_container">
         <Menu />
        </div>
      </div>
      <div className="navbar-sign">
      
        <>
        <a href="https://rarible.com/ParLock" style={{position:'absolute', right:'-3%', marginBottom: -6}}> 
        <img src={rarible} alt="logo" style={{height: '8.5%', width: '8.5%', borderRadius: 100, borderColor:'#ffff', borderWidth: 1}} className='footer-icon'/>
        </a>
        <a href="https://opensea.io/Parlock" style={{position:'absolute', right:'-9%', marginBottom: 2}}> 
        <img src={opensea} alt="logo" style={{height: '6.5%', width: '6.5%', borderRadius: 100, borderColor:'#ffff', borderWidth: 1}} className='footer-icon'/>
        </a>
        
        <a href="https://www.instagram.com/parlock.kk_kreative_edition/"> 
        <AiOutlineInstagram size={25} color='white' className='footer-icon' />
        </a>
        <a href="https://twitter.com/Kkk90513327"> 
        <AiOutlineTwitter size={25} color='white' className='footer-icon'/>
        </a>
        </>
      
       

       
      </div>
      <div className="navbar-menu">
        {toggleMenu ? 
        <RiCloseLine  color="#fff" size={27} onClick={() => setToggleMenu(false)} /> 
        : <RiMenu3Line color="#fff" size={27} onClick={() => setToggleMenu(true)} />}
        {toggleMenu && (
          <div className="navbar-menu_container scale-up-center" >
            <div className="navbar-menu_container-links" style={{position:'fixed'}}>
             <Menu />
            </div>
            <div className="navbar-menu_container-links-sign">
            {user ? (
              <>
              <Link to="/create"> 
                <button type='button' className='primary-btn' >Create</button>
              </Link>
              <button type='button' className='secondary-btn'>Connect</button>
              </>
            ): (
              <>
              <a href="https://www.instagram.com/parlock.kk_kreative_edition/"> 
              <AiOutlineInstagram size={25} color='white' className='footer-icon' />
              </a>
              <a href="https://twitter.com/Kkk90513327"> 
              <AiOutlineTwitter size={25} color='white' className='footer-icon'/>
              </a>
              </>
            )}
           
            </div>
            </div>
        )}
      </div>
    </div>
  )
}

export default Navbar
